import { useCallback, useMemo } from 'react';

export const useCurrency = () => {
  const currencyDelimiter = useMemo(() => ' ', []);

  const getDefaultCurrencyNumber = useCallback(
    (value?: string | number) => {
      if (!value) return '';

      return value
        ?.toString()
        ?.replace(/\B(?=(\d{3})+(?!\d))/g, currencyDelimiter);
    },
    [currencyDelimiter],
  );

  return {
    getDefaultCurrencyNumber,
  };
};
